import { Container, Row } from "reactstrap"
import { Breadcrumbs } from "../../../AbstractElements"
import { FormLayout, TwoFactorHeading } from "../../../Constant"
import TwoFactorAuthentication from "./TwoFactorAuthentication"
import EmailVerification from "./EmailVerification"

const TwoFactorContainer = () => {
  return (
    <>
    <Breadcrumbs pageTitle={TwoFactorHeading} parent={FormLayout} title={TwoFactorHeading}      />
      <Container fluid>
        <Row>
          <TwoFactorAuthentication />
          <EmailVerification />
        </Row>
      </Container>
    </>
  )
}

export default TwoFactorContainer